import { ApiProperty } from "@nestjs/swagger";

export class ItemRemovedQty{
    @ApiProperty()
    packingMaterialId?:number;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    itemId:number;
    @ApiProperty()
    removedQuantity:number;
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    createdUser?:string;
    @ApiProperty()
    locationWiseStock?:any[]


    constructor(packingMaterialId:number, itemId:number, saleOrderId:number, removedQuantity:number,  unitId?: number,createdUser? : string,locationWiseStock?:any[]){
        this.packingMaterialId = packingMaterialId;
        this.itemId = itemId;
        this.removedQuantity = removedQuantity;
        this.saleOrderId = saleOrderId;
        this.unitId = unitId;
        this.createdUser = createdUser;
        this.locationWiseStock = locationWiseStock;
    }
}